import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-enterprise';

@Component({
    selector: 'app-loading-cell-renderer',
    template: `<i class="fa fa-circle-notch fa-spin fa-5x text-gray-500"></i>`,
    standalone: false
})
export class CustomLoadingOverlayComponent
  implements ILoadingOverlayAngularComp
{
  agInit(): void {}
}
